import { render } from "./ClusterStats.vue?vue&type=template&id=2a0b9fad"
import script from "./ClusterStats.vue?vue&type=script&lang=js"
export * from "./ClusterStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__